/**
 * @generated SignedSource<<11f1293793c081a54679c5f133455032>>
 * @relayHash 21e9e53b2348b2584c57975e0a8089b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 144480b55dc7e0d1d2ae38d1081acaf41287b703093144186663da48f81c8f0c

import type { ConcreteRequest } from 'relay-runtime';
export type GraphQLContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "%future added value";
export type ContentSpecificCreateInput = {
  key: string;
  value: string;
};
export type CreateSmartLinkEmbedMutation$variables = {
  contentSpecificCreateInput?: ReadonlyArray<ContentSpecificCreateInput> | null;
  parentId?: string | null;
  spaceKey?: string | null;
  status: GraphQLContentStatus;
  title?: string | null;
  type: string;
};
export type CreateSmartLinkEmbedMutation$data = {
  readonly createContentContextual: {
    readonly id: string | null;
    readonly space: {
      readonly alias: string | null;
      readonly id: string | null;
      readonly key: string | null;
    } | null;
  } | null;
};
export type CreateSmartLinkEmbedMutation = {
  response: CreateSmartLinkEmbedMutation$data;
  variables: CreateSmartLinkEmbedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentSpecificCreateInput"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentSpecificCreateInput",
            "variableName": "contentSpecificCreateInput"
          },
          {
            "kind": "Variable",
            "name": "parentId",
            "variableName": "parentId"
          },
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
          },
          {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
          },
          {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "createContentContextual",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "alias"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CreateSmartLinkEmbedMutation",
    "selections": (v7/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateSmartLinkEmbedMutation",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "21e9e53b2348b2584c57975e0a8089b1",
    "id": "144480b55dc7e0d1d2ae38d1081acaf41287b703093144186663da48f81c8f0c",
    "metadata": {},
    "name": "CreateSmartLinkEmbedMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSmartLinkEmbedMutation($contentSpecificCreateInput:[ContentSpecificCreateInput!],$parentId:ID,$spaceKey:String,$title:String,$type:String!,$status:GraphQLContentStatus!){createContentContextual(input:{contentSpecificCreateInput:$contentSpecificCreateInput,parentId:$parentId,spaceKey:$spaceKey,title:$title,type:$type,status:$status}){id,space{id,key,alias}}}"
  }
};
})();

(node as any).hash = "5eab7a8e9a9ef38299fc481acc494cd9";

export default node;
